const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHost(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.623 35.708a3 3 0 0 0-2.993 2.934c-5.238 1.891-12.121 2.2-14.007 2.251v-.185h-4a4 4 0 0 0-4 4v5a4 4 0 0 0 4 4h2.757l1.307 6.49a4.381 4.381 0 0 0 4.292 3.509 4.43 4.43 0 0 0 .874-.088 2.247 2.247 0 0 0 1.723-2.64l-.507-2.515a4.892 4.892 0 0 0 4.344-3.836 29.117 29.117 0 0 1 3.21.94v.14a3 3 0 0 0 6 0v-17a3 3 0 0 0-3-3zm-19 16h-2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h2zm6.821 9.953a2.381 2.381 0 0 1-2.8-1.883l-1.3-6.434c.678.028 1.6.078 2.683.169l1.586 7.866a.239.239 0 0 1-.169.282zm1.23-5.157-.561-2.781c1.06.124 2.189.287 3.342.5a2.9 2.9 0 0 1-2.781 2.277zm-6.051-5.187V42.9a53.344 53.344 0 0 0 14-2.131v12.679a53.344 53.344 0 0 0-14-2.131zm18 4.391a1 1 0 0 1-2 0v-17a1 1 0 0 1 2 0z",
    transform: "translate(-504.623 -31.708)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHost);
export default __webpack_public_path__ + "static/media/icon-host.96facb4457a14ba9f642a203e2314e4c.svg";
export { ForwardRef as ReactComponent };